import React from "react";
import { TreatmentItem } from "../../../../../components/treatments/TreatmentItem";
import instance, { url } from "../../../../../axios/instance";
import { Back } from "iconsax-react";
import { useNavigate, useLoaderData } from "react-router-dom";
import { getToken } from "../../../../../utils/token";

export const newTreatmentLoader = async () => {
  const token = getToken();

  const user = await instance.get("/doctor", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return { user: user.data };
};

export const NewTreatmentPage = () => {
  const { user } = useLoaderData();
  const navigate = useNavigate();
  
  const sampleData = {
    title: "Compounded Semaglutide",
    subtitle: "Same active ingredient as Wegovy",
    instock: "true",
    description:
      "We understand weight loss isn't about willpower- it's about consistency. Lose up to 14.9% of your body weight with this simple, weekly GLP-1-- tailored just to you.",
    description_list: [
      { text: "Same active ingredient in Wegovy and Ozempic", icon: "Pill" },
      {
        text: "Personalized weight loss plans from Eden's licensed medical professionals",
        icon: "Heart",
      },
      {
        text: "Same price at every dose with no hidden fees.",
        icon: "Activity",
      },
    ],
    payment_type: "one-time",
    subscription_plans: null,
    price: '',
    image_url: `${url}/uploads/treatments/images/1a1a1a1a1a.png`,
    discount: '',
    expires: ''
  };

  const isAdmin = user.access === "admin";

  return (
    <div className="px-7 py-5 w-full">
      <div className="flex gap-x-2 mb-4 items-center">
        <Back
          size={30}
          onClick={() => navigate("/dashboard/settings/treatment-setup/treatments")}
          className="hover:text-primary cursor-pointer"
        />
        <div className="font-medium text-[17px]">Create new treatment</div>
      </div>
      <span className="text-gray-700 block mb-4">
        Example below is only of a sample data:
      </span>
      <TreatmentItem treatment={sampleData} isAdmin={isAdmin} />
    </div>
  );
};
